import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getUmsatzsteuerCodesOptions } from "../constants"
import { ZuAbschlag } from "../models/rechnung/rechnungsebene/zuAbschlag"

interface RechnungAbschlagViewProps {
    index: number
    abschlag: ZuAbschlag
    onRemove: (idx: number) => void
    onChange: (idx: number) => (value: any) => void
}

export function RechnungNachlassView({ index, abschlag, onRemove, onChange }: RechnungAbschlagViewProps) {
    const { t } = useTranslation()
    const umsatzsteuerCodesOptions = getUmsatzsteuerCodesOptions()
    return (
        <div className="nachlass">
            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.nachlassNetto.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, nachlassNetto: v } })}
                    value={abschlag.zuAbschlaege.nachlassNetto ?? null}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.grundbetragNetto.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grundbetragNetto: v } })}
                    value={abschlag.zuAbschlaege.grundbetragNetto ?? null}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.prozentsatz.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, prozentsatz: v } })}
                    value={abschlag.zuAbschlaege.prozentsatz ?? null}
                    suffix=" %"
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.umsatzsteuerkategorie.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.rechnungAbschlaege.umsatzsteuerkategorie.placeholder")}
                    onChange={(v) => onChange(index)({ ...abschlag, umsatzsteuerkategorie: v })}
                    value={umsatzsteuerCodesOptions.find((o) => o.value === abschlag.umsatzsteuerkategorie)}
                    options={umsatzsteuerCodesOptions}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.umsatzsteuersatz.label")}>
                <Components.NumberEdit
                    onChange={(v) => onChange(index)({ ...abschlag, umsatzsteuersatz: v })}
                    value={abschlag.umsatzsteuersatz ?? null}
                    suffix=" %"
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.grund.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungAbschlaege.grund.placeholder")}
                    onChange={(v: string) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grund: v } })}
                    value={abschlag.zuAbschlaege.grund}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungAbschlaege.grundCode.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungAbschlaege.grundCode.placeholder")}
                    onChange={(v: string) => onChange(index)({ ...abschlag, zuAbschlaege: { ...abschlag.zuAbschlaege, grundCode: v } })}
                    value={abschlag.zuAbschlaege.grundCode}
                />
            </Components.FormGroup>

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.rechnungAbschlaege.loeschen")}
                        onClick={() => onRemove(index)}
                    />
                </Components.Col>
            </Components.Row>
        </div>
    )
}
